export default __webpack_public_path__ + "static/2422-26b62fc800423aafde5322c4c86f1c7a.gif";